/**
 * Browser tab title from config.json: dbName plus TST when isForTesting.
 */
export const PLATFORM_TAB_BASE_TITLE = 'Trazit Platform';

export function buildPlatformDocumentTitle(config, baseTitle = PLATFORM_TAB_BASE_TITLE) {
  const dbName = String(config?.dbName ?? '').trim();
  const testingSuffix = config?.isForTesting === true ? ' TST' : '';
  if (dbName) {
    return `${baseTitle} - ${dbName}${testingSuffix}`;
  }
  return `${baseTitle}${testingSuffix}`;
}
